import { PushSubscriptions } from '../pwa/types';
export const reduxKey = '@@pwa';

export const DEFAULT_PUSH_SUBSCRIPTIONS: PushSubscriptions = {
  note: true,
  commentReply: true,
  watcher: true,
  mention: true,
  favourite: true,
  favouriteMilestone: false,
};

export const PWA_COOKIE_NAME = 'pwae';
export const PWA_COOKIE_VALUE = '1';
